import * as fromModels from '../../models/rootState.model';
import * as fromActions from '../actions/internet.actions';
import { StoreAction } from '../../models/rootState.model';


const INITAL_STATE: fromModels.InternetState = {
    lastChange: null,
    online: null
}

export function InternetReducer(
    state = INITAL_STATE,
    action: StoreAction
): fromModels.InternetState {

    switch (action.type) {

        case fromActions.INTERNET_ACTION_TYPES.INTERNET_ONLINE: {
            let st = { ...state, online: true }
            if (!state.online) {
                st.lastChange = new Date();
            }

            return st;
        }

        case fromActions.INTERNET_ACTION_TYPES.INTERNET_OFFLINE: {
            let st = { ...state, online: false }
            if (state.online) {
                st.lastChange = new Date();
            }
            return st;
        }

        default: { return state}
    }
}